import React from "react";
import { Order } from "@/types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import Accordion from "@/components/organisms/AccordionDrawer";
import Text from "@/components/atoms/Text";
import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";
import { useAuth } from "@/contexts/AuthContext";
import { useGetContractById } from "@/services/Contracts";

interface AccordionGeneralProps {
  order: Order;
}

const AccordionGeneral = ({ order }: AccordionGeneralProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data: contract } = useGetContractById(order.contractId as number, {
    enabled: !!order.contractId,
  });
  const poNumber = contract?.poNumber;

  return (
    <Accordion
      initiallyOpen
      title={order.orderType.id === OrderTypeEnum.SELL ? t("orders:sellProduct") : t("orders:purchaseProduct")}
    >
      <Grid p={20}>
        <Grid.Col span={3}>
          <Text size="sm" color={"secondary"}>
            {t("product:product")}
          </Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text size="sm">
            {order.salesItem.nameTranslated?.[user?.language?.id as number] ?? order.salesItem.salesItem}
          </Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text size="sm" color={"secondary"}>
            {t("orders:estimatedAmount")}
          </Text>
        </Grid.Col>
        <Grid.Col span={9}>{`${order.amount} ${order.unit.unit}`}</Grid.Col>
        {poNumber && (
          <React.Fragment>
            <Grid.Col span={3}>
              <Text size="sm" color={"secondary"}>
                {t("contracts:purchaseOrderNumber")}
              </Text>
            </Grid.Col>
            <Grid.Col span={9}>
              <Text size="sm" data-testid="order-po-number">
                {poNumber}
              </Text>
            </Grid.Col>
          </React.Fragment>
        )}
        {order.batchNumber && (
          <React.Fragment>
            <Grid.Col span={3}>
              <Text size="sm" color={"secondary"}>
                {t("common:batchNumber")}
              </Text>
            </Grid.Col>
            <Grid.Col span={9}>
              <Text size="sm" data-testid="order-batch-number">
                {order.batchNumber}
              </Text>
            </Grid.Col>
          </React.Fragment>
        )}
      </Grid>
    </Accordion>
  );
};

export default AccordionGeneral;
